export const graduates = [
  // Sample placeholder data - clearly marked as examples
  {
    id: 'sample-1',
    name: 'Maria Santos (Sample)',
    program: 'Educational Support Program',
    initiative: 'Scholarship Recipient',
    story: 'This is a sample profile demonstrating how graduate stories will be displayed. Maria represents the future students whose lives will be transformed through educational support.',
    photoUrl: '',
    graduationYear: null,
    isSample: true,
  },
  {
    id: 'sample-2',
    name: 'Juan dela Cruz (Sample)',
    program: 'Career Development Initiative',
    initiative: 'Mentorship Program',
    story: 'This sample profile shows how we will celebrate graduates who have completed our career development programs and found meaningful employment.',
    photoUrl: '',
    graduationYear: null,
    isSample: true,
  },
];

export const getGraduatesByYear = (year) => {
  return graduates.filter(grad => grad.graduationYear === year);
};

export const getGraduatesByProgram = (program) => {
  return graduates.filter(grad => grad.program === program);
};
